/** @format */

import template from './gb-donation-item-amount.html';

export const GbDonationItemAmountComponent = {
    template,
    require: {
        gbApp: '^^',
    },
    bindings: {
        donationItem: '<',
    },
    controller: class GbDonationItemAmountComponent {
        constructor() {
            'ngInject';
        }
    },
};
